import { Component, HostBinding, Input, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { LorenzControlTypeEnum, LorenzFormComponentDisplayOptions, LorenzFormGroup, LorenzFormGroupComponent, LorenzFormList } from '@lib/forms';
import { TranslateModule } from '@ngx-translate/core';
import { LibSharedButtonComponent } from '@lib/shared';

@Component({
	selector: 'lib-form-component-list',
	imports: [TranslateModule, LibSharedButtonComponent],
	templateUrl: './lorenz-form-list.component.html',
	styleUrl: './lorenz-form-list.component.scss'
})
export class LorenzFormListComponent implements OnInit {
	protected readonly LorenzControlTypeEnum = LorenzControlTypeEnum;

	@Input({ required: false, alias: 'list' }) lorenzFormList: LorenzFormList | null = null;

	@Input({ required: false, alias: 'options' }) lorenzFormComponentOptions: LorenzFormComponentDisplayOptions = {};

	@HostBinding('attr.id') id: string | null = null;

	@HostBinding('attr.class') hostCssClass: string | null = null;

	@ViewChild('container', { read: ViewContainerRef, static: true }) container!: ViewContainerRef;

	public ngOnInit(): void {
		if (this.lorenzFormList && this.lorenzFormList.items) {
			this.id = this.lorenzFormList.getFullKey();
			// prettier-ignore
			this.hostCssClass = [
				'list',
				this.lorenzFormComponentOptions?.layout ?? this.lorenzFormList.getLayout(),
				this.lorenzFormList.getKey()
			].join(' ').trim();

			this.container?.clear();
			this.lorenzFormList.payload.listComponentRefs = [];

			this.lorenzFormList?.items.forEach((lorenzFormGroup: LorenzFormGroup) => {
				this.createListItem(lorenzFormGroup);
			});
		}
	}

	get getAddButtonText(): string {
		return this.lorenzFormList?.getAddButtonText() ?? '';
	}

	get addButtonDisabled(): boolean {
		const help = this.lorenzFormList?.valid ?? false;
		return !help;
	}

	get hasAddButton(): boolean | null {
		return this.lorenzFormList?.hasAddButton() ?? null;
	}

	public addListItem() {
		if (this.lorenzFormList) {
			const lorenzFormGroup = this.lorenzFormList.addItem();
			if (lorenzFormGroup) {
				this.createListItem(lorenzFormGroup);
			}
		}
	}

	private createListItem(lorenzFormGroup: LorenzFormGroup) {
		if (this.lorenzFormList && this.lorenzFormList.payload.listComponentRefs) {
			lorenzFormGroup.payload.listItemComponentRef = this.container.createComponent(LorenzFormGroupComponent);
			lorenzFormGroup.payload.listItemComponentRef.instance.lorenzFormGroup = lorenzFormGroup;
			lorenzFormGroup.payload.listItemComponentRef.instance.lorenzFormComponentOptions = this.lorenzFormComponentOptions;
			this.lorenzFormList.payload.listComponentRefs.push(lorenzFormGroup.payload.listItemComponentRef);
		}
	}
}
